__turbopack_context__.v({
  "className": "instrument_serif_538f1044-module__WwGC-a__className",
  "variable": "instrument_serif_538f1044-module__WwGC-a__variable",
});
